<template>
  <v-content>
    <router-view />
    <footer />
  </v-content>
</template>

<script>
  export default {
    name:'AppView',
    components: {
      Footer: () => import('./Footer'),
    },
  }
</script>
